import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  changeCouponStatusApi,
  createCouponApi,
  deleteCouponApi,
  getCouponApi,
  getCouponsListApi,
  issueCouponApi,
  updateCouponApi,
} from '@src/api/coupons';
import { ChangeStatusParams, CouponListParams } from '@src/api/coupons/coupons';
import { Coupon } from '@src/types/coupon';

const getCouponList = createAsyncThunk(
  'coupons/getCouponList',
  async (params: CouponListParams, { rejectWithValue }) => {
    try {
      const response = await getCouponsListApi(params);
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const getCoupon = createAsyncThunk(
  'coupon/get',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await getCouponApi(id);
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const updateCoupon = createAsyncThunk(
  'coupon/update',
  async ({ id, data }: { id: string; data: Coupon }, { rejectWithValue }) => {
    try {
      await updateCouponApi(id, data);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

const updateCouponStatus = createAsyncThunk(
  'coupon/updateStatus',
  async (params: ChangeStatusParams, { rejectWithValue }) => {
    try {
      await changeCouponStatusApi(params);
      return params;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

const deleteCoupon = createAsyncThunk(
  'coupon/delete',
  async (id: string, { rejectWithValue }) => {
    try {
      await deleteCouponApi(id);
      return id;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

const createCoupon = createAsyncThunk(
  'coupon/create',
  async (params: Coupon, { rejectWithValue }) => {
    try {
      await createCouponApi(params);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

const issueCoupon = createAsyncThunk(
  'coupon/issue',
  async (
    { id, companyId }: { id: string; companyId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await issueCouponApi(id, companyId);
      return response;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        throw rejectWithValue(err.response?.data);
      }
    }
  }
);

export {
  getCouponList,
  getCoupon,
  updateCoupon,
  updateCouponStatus,
  deleteCoupon,
  createCoupon,
  issueCoupon,
};
